import {
  GET_BROWSE_ERROR,
  GET_BROWSE_REQUEST,
  GET_BROWSE_SUCCESS,
  GET_TOPICS_SUCCESS,
} from "../../store/actionTypes";

export function reducer(state, { type, viewModel, browsePath, statusCode }) {
  switch (type) {
    case GET_BROWSE_REQUEST:
      return {
        ...state,
        [browsePath]: {
          ...state[browsePath],
          hasError: false,
          isLoading: true,
        },
      };
    case GET_BROWSE_SUCCESS:
      return {
        ...state,
        [browsePath]: {
          ...state[browsePath],
          viewModel,
          hasError: false,
          isLoading: false,
        },
      };
    case GET_BROWSE_ERROR:
      return {
        ...state,
        [browsePath]: {
          ...state[browsePath],
          hasError: true,
          statusCode,
          isLoading: false,
        },
      };
    case GET_TOPICS_SUCCESS:
      return {
        ...state,
        [browsePath]: {
          ...state[browsePath],
          viewModel: {
            ...state[browsePath].viewModel,
            cdhTopics: {
              ...state[browsePath].viewModel.cdhTopics,
              ...viewModel.cdhTopics,
            },
            ...(viewModel.excludedContent && {
              excludedContent: {
                ...state[browsePath].viewModel.excludedContent,
                ...viewModel.excludedContent,
              },
            }),
          },
          hasError: false,
          isLoading: false,
        },
      };
    default:
      return state;
  }
}
